import { useUIThemeContext } from "@pathwright/ui/src/components/ui/PathwrightUI"
import { useSyncPlanContext } from "@pathwright/web/src/modules/path/sync/SyncPlanContext"
import { ConnectStores } from "lib/core/store"

const ItemPublishStatus = function ({ item, offering }) {
  const theme = useUIThemeContext()
  const { forward, ...rest } = useSyncPlanContext()

  // item needs publishing if a created change exists for this item
  const needsPublish =
    !!forward &&
    !!forward.includedChanges.find(
      (change) =>
        change.item_source_id === item.sync_source_id &&
        change.change_details.created
    ) &&
    offering.is_curriculum

  const needsContent =
    item.item_type === "A" && (!item.content || !item.content.id)

  return null

  // if (needsContent) {
  //   return (
  //     <span
  //       className="ItemPublishStatus"
  //       style={{ color: theme.primaryBrandColor }}
  //     >
  //       Needs Content
  //     </span>
  //   )
  // } else if (needsPublish) {
  //   return (
  //     <span
  //       className="ItemPublishStatus"
  //       style={{ color: theme.primaryBrandColor }}
  //     >
  //       Unsynced
  //     </span>
  //   )
  // } else {
  //   return null
  // }
}

ItemPublishStatus.displayName = "ItemPublishStatus"

const mapStateToProps = (state, ownProps) => {
  const { offering } = state.resourceStore.state

  return {
    offering,
    ...ownProps
  }
}

const ConnectedItemPublishStatus = ConnectStores(
  ItemPublishStatus,
  [{ store: "resource", watch: false }],
  {},
  mapStateToProps
)

export default ConnectedItemPublishStatus
